import { calculateAccuracy } from "@helpers/common";
import { useAppTheme } from "@hooks/useAppTheme";
import { useDevice } from "@hooks/useDevice";
import Box from "@memorang/ui/src/components/Box";
import { CustomListSubheader } from "@memorang/ui/src/components/CustomListSubheader";
import DonutScore from "@memorang/ui/src/components/DonutScore";
import { List, Surface, Text } from "react-native-paper";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import AnswerStatusRow from "./AnswerStatusRow";

type FooterProps = {
	numTotalTopics: number;
	numTotalItems: number;
	numCorrectItems: number;
	numIncorrectItems: number;
	numSkippedItems: number;
};

const Footer = ({
	numTotalItems,
	numCorrectItems,
	numIncorrectItems,
	numSkippedItems,
}: FooterProps) => {
	const accuracy = calculateAccuracy({
		numCorrect: numCorrectItems,
		numTotal: numTotalItems,
	});
	const theme = useAppTheme();
	const insets = useSafeAreaInsets();

	const { isMobile } = useDevice();

	const Content = () => {
		return (
			<>
				<CustomListSubheader
					style={{
						backgroundColor: theme.colors.elevation.level2,
					}}
				>
					Overall
				</CustomListSubheader>
				<List.Item
					title="All items"
					descriptionStyle={{
						paddingTop: 8,
					}}
					right={(props) => {
						return isMobile ? null : (
							<List.Icon
								{...props}
								icon={() => {
									return (
										<AnswerStatusRow
											numCorrect={numCorrectItems}
											numIncorrect={numIncorrectItems}
											numSkipped={numSkippedItems}
										/>
									);
								}}
							/>
						);
					}}
					left={(props) => {
						return (
							<List.Icon
								{...props}
								icon={() => (
									<DonutScore
										distribution={[
											numCorrectItems,
											numTotalItems - numCorrectItems,
										]}
										score={accuracy}
										variant="progress"
										radius={20}
										innerRadius={18}
										customChildren={
											<Text
												variant="labelSmall"
												style={{ fontSize: 10, fontWeight: "600" }}
											>
												{accuracy}%
											</Text>
										}
									/>
								)}
							/>
						);
					}}
					description={
						isMobile && (
							<AnswerStatusRow
								numCorrect={numCorrectItems}
								numIncorrect={numIncorrectItems}
								numSkipped={numSkippedItems}
							/>
						)
					}
				/>
			</>
		);
	};

	if (!isMobile) {
		return (
			<Box>
				<Content />
			</Box>
		);
	}
	return (
		<Surface
			style={{
				paddingBottom: insets.bottom,
			}}
		>
			<Content />
		</Surface>
	);
};

export default Footer;
